import React from 'react';
import styled from 'styled-components';
import {ValueFormatter} from '@epic-visualizations/charts';

import PlayrateTooltipLabel from './PlayrateTooltipLabel';
import PlayrateTooltipLegend from './PlayrateTooltipLegend';

const StyledLabelContainer = styled.div`
    line-height: 100%;
`;

export interface PlayrateTooltipParams {
    tooltipFormatter: ValueFormatter<string | number>;
}

const PlayrateTooltip = ({tooltipFormatter}: PlayrateTooltipParams) => ({
    payload
}: {
    payload: any;
}) =>
    payload.map(({stroke, name, value, payload: {percentage}}, index) => (
        <React.Fragment key={name}>
            {index === 0 && (
                <StyledLabelContainer>
                    <PlayrateTooltipLabel label={percentage} />
                </StyledLabelContainer>
            )}
            <PlayrateTooltipLegend color={stroke} value={tooltipFormatter(value)} />
        </React.Fragment>
    ));

export default PlayrateTooltip;
